import StadiumRemote from '../remote/stadiumRemote'

// temporary till PR #3395 is merged
const createOrderParams = (order) => {
  const ORDER_CREATION_PARAMS = [
    'clientCreatedAt',
    'standMenuUuid',
    'orderMenuItems',
    'orderNumber',
    'payments',
    'webOrder',
    'uuid',
    'affiliations',
    'tipAmountInCents',
    'userNotes',
    'employeeId',
    'userAttributes',
    'userName',
    'state',
    'promotions',
    'receiptSignature',
  ]

  // Filter the order map to include only the necessary fields.
  return Object.keys(order || {}).reduce((acc, key) => {
    if (ORDER_CREATION_PARAMS.includes(key)) acc[key] = order[key]

    return acc
  }, {})
}

/**
 * Syncs the order to stadium
 *
 * @returns {Boolean} successful or failed
 */
export const createOrder = async (curOrder) => {
  try {
    const result = await StadiumRemote.createPosOrder({
      ...createOrderParams(curOrder),
      ...createOrderParams(curOrder.createOrderParams),
      webOrder: true,
    })

    if (result?.status !== 201) {
      throw new Error('Failed to create order')
    }

    return true
  } catch (error) {
    return false
  }
}
